.portfolioCard {
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 13px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.portfolioCard:hover {
  box-shadow: 0 2px 8px rgba(27, 37, 52, 0.09), 0 16px 34px rgba(120, 30, 30, 0.1);
  transform: translateY(-1px);
}

/* keep real content above the faded logo watermark */
.portfolioCard > *:not(.watermark) {
  position: relative;
  z-index: 1;
}

.watermark {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.05;
  pointer-events: none;
  overflow: hidden;
}

.watermarkImg {
  height: 150px;
  width: auto;
  max-width: none;
  object-fit: contain;
  transform: translateY(6px);
}

.cTop {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px 8px 18px;
}

.portfolioLogo {
  height: 26px;
  width: auto;
  max-width: 130px;
  object-fit: contain;
  display: block;
}

.badge {
  margin-left: auto;
  flex: none;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 4px 9px;
  border-radius: 6px;
  background: var(--ib-chip);
  color: var(--ib-muted);
  white-space: nowrap;
}

.cCode {
  padding: 0 18px;
  font-size: 11px;
  color: var(--ib-faint);
  letter-spacing: 0.04em;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-variant-numeric: tabular-nums lining-nums;
}

.hero {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  padding: 12px 18px 14px 18px;
}

.heroStat {
  display: flex;
  flex-direction: column;
}

.heroNum {
  font-family: -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  font-size: 25px;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 0.95;
  color: var(--ib-ink);
  font-variant-numeric: tabular-nums lining-nums;
}

.irrNum {
  font-family: -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  font-size: 29px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 0.9;
  color: var(--ib-ink);
  font-variant-numeric: tabular-nums lining-nums;
}

.irrUnit {
  font-size: 16px;
  font-weight: 700;
  color: var(--ib-red);
  margin-left: 1px;
}

.heroLabel {
  font-size: 11px;
  color: var(--ib-muted);
  font-weight: 600;
  margin-top: 7px;
}

.heroSep {
  width: 1px;
  align-self: stretch;
  background: var(--ib-line);
  margin: 4px 0;
}

.portfolioAttributes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px 18px;
  padding: 12px 18px 4px 18px;
  border-top: 1px solid var(--ib-line-2);
  align-items: start;
}

.divider {
  display: none;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 6px 18px 16px 18px;
}

.documents {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.footerAttributes {
  display: flex;
  flex: 1;
  min-width: 0;
}

/* Footer action buttons — scoped overrides layered on the shared <Button> */
.footerBtnGhost,
.footerBtnPrimary {
  width: 100%;
  border-radius: 8px;
  font-weight: 700;
  font-size: 12.5px;
  letter-spacing: 0.01em;
  padding: 9px 12px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.footerBtnGhost {
  background: var(--ib-panel) !important;
  color: var(--ib-ink) !important;
  border: 1px solid var(--ib-line) !important;
}

.footerBtnGhost:hover {
  border-color: var(--ib-muted) !important;
  color: var(--ib-red) !important;
}

.footerBtnPrimary {
  background: var(--ib-red) !important;
  color: #ffffff !important;
  border: 1px solid var(--ib-red) !important;
}

.footerBtnPrimary:hover {
  background: var(--ib-red-d) !important;
  border-color: var(--ib-red-d) !important;
}

@media (max-width: 767.98px) {
  .portfolioAttributes {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 430px) {
  .portfolioAttributes {
    grid-template-columns: 1fr 1fr;
  }
}
